import React from 'react';
import ImageUrlField from './ImageUrlField';
import './SectionBuilder.css';

const SECTION_TYPES = [
  { value: 'hero', label: 'Hero' },
  { value: 'text', label: 'Text Block' },
  { value: 'image', label: 'Image' },
  { value: 'cta', label: 'Call to Action' },
  { value: 'faq', label: 'FAQ' },
  { value: 'reviews', label: 'Reviews' },
  { value: 'bannerCarousel', label: 'Banner Carousel' },
  { value: 'newsletter', label: 'Newsletter' },
];

const SectionBuilder = ({ sections = [], onChange }) => {
  const addSection = (type) => {
    const newSection = { type, order: sections.length, data: {} };
    onChange([...sections, newSection]);
  };

  const updateSection = (index, data) => {
    const updated = sections.map((s, i) => (i === index ? { ...s, data: { ...s.data, ...data } } : s));
    onChange(updated);
  };

  const removeSection = (index) => {
    onChange(sections.filter((_, i) => i !== index));
  };

  const moveSection = (index, dir) => {
    const newSections = [...sections];
    const target = index + dir;
    if (target < 0 || target >= newSections.length) return;
    [newSections[index], newSections[target]] = [newSections[target], newSections[index]];
    onChange(newSections.map((s, i) => ({ ...s, order: i })));
  };

  return (
    <div className="section-builder">
      <div className="section-add-buttons">
        {SECTION_TYPES.map((t) => (
          <button key={t.value} type="button" onClick={() => addSection(t.value)}>+ {t.label}</button>
        ))}
      </div>
      {sections.map((section, index) => (
        <div key={index} className="section-item">
          <div className="section-item-header">
            <strong>{section.type}</strong>
            <div>
              <button type="button" onClick={() => moveSection(index, -1)} disabled={index === 0}>↑</button>
              <button type="button" onClick={() => moveSection(index, 1)} disabled={index === sections.length - 1}>↓</button>
              <button type="button" className="remove-btn" onClick={() => removeSection(index)}>×</button>
            </div>
          </div>
          {section.type === 'hero' && (
            <>
              <input placeholder="Title" value={section.data.title || ''} onChange={(e) => updateSection(index, { title: e.target.value })} />
              <input placeholder="Subtitle" value={section.data.subtitle || ''} onChange={(e) => updateSection(index, { subtitle: e.target.value })} />
              <ImageUrlField
                label="Background Image"
                value={section.data.backgroundImage || ''}
                onChange={(url) => updateSection(index, { backgroundImage: url })}
                folder="cms"
                placeholder="https://... or upload"
              />
              <input placeholder="CTA Text" value={section.data.ctaText || ''} onChange={(e) => updateSection(index, { ctaText: e.target.value })} />
              <input placeholder="CTA Link" value={section.data.ctaLink || ''} onChange={(e) => updateSection(index, { ctaLink: e.target.value })} />
            </>
          )}
          {section.type === 'text' && (
            <textarea rows={4} placeholder="HTML content" value={section.data.html || ''} onChange={(e) => updateSection(index, { html: e.target.value })} />
          )}
          {section.type === 'image' && (
            <>
              <ImageUrlField
                label="Image"
                value={section.data.url || ''}
                onChange={(url) => updateSection(index, { url })}
                folder="cms"
                placeholder="https://... or upload"
              />
              <input placeholder="Alt text" value={section.data.alt || ''} onChange={(e) => updateSection(index, { alt: e.target.value })} />
            </>
          )}
          {section.type === 'cta' && (
            <>
              <input placeholder="Button text" value={section.data.text || ''} onChange={(e) => updateSection(index, { text: e.target.value })} />
              <input placeholder="Link" value={section.data.link || ''} onChange={(e) => updateSection(index, { link: e.target.value })} />
            </>
          )}
          {(section.type === 'faq' || section.type === 'reviews') && (
            <textarea
              rows={4}
              placeholder={section.type === 'faq' ? 'JSON: [{"question":"...","answer":"..."}]' : 'JSON: ["quote1","quote2"]'}
              value={JSON.stringify(section.data.items || section.data.quotes || [], null, 2)}
              onChange={(e) => {
                try {
                  const parsed = JSON.parse(e.target.value);
                  updateSection(index, section.type === 'faq' ? { items: parsed } : { quotes: parsed });
                } catch { /* ignore invalid JSON while typing */ }
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SectionBuilder;
